export default __webpack_public_path__ + "static/youthcybersecurity2020-899b314fc127b11c935481a89db2ade2.jpg";